module.exports = __webpack_public_path__ + "static/media/logo_ko.7cc6addb.jpg";